<template>
  <div class="review-list" v-loading="loading">
    <ul class="verify-box">
      <template v-for="item in reviewList">
        <li :key="item.id" v-if="item.scene==0 || (item.scene == showType)">
          <el-row style="width:100%">
            <el-col :xs="24" :md="12" :lg="12" :xl="12">
              <p v-if="item.is_must" class="red-mark">
                {{item.twname}} *
              </p>
              <p v-else>
                {{item.twname}}
              </p>
            </el-col>
            <el-col :xs="24" :md="12" :lg="12" :xl="12">
              <p v-if="item.options_type==0">
                <el-switch :disabled="disabled" style="display: block;min-width:120px;" v-model="formData['review_'+item.id]" active-color="#13ce66" inactive-color="#ff4949" :active-value="item.switchDefaultValue[0]" :inactive-value="item.switchDefaultValue[1]" :active-text="item.switchDefaultValue[0]" :inactive-text="item.switchDefaultValue[1]">
                </el-switch>
              </p>
              <p v-if="item.options_type==1">
                <el-select :disabled="disabled" style="margin-right:5px;display: block;min-width:120px;" v-model="formData['review_'+item.id]" :placeholder="'選擇'">
                  <el-option v-for="options in item.options" :key="options.twname" :label="options.twname" :value="options.twname">
                  </el-option>
                </el-select>
                <el-input :disabled="disabled" v-if="item.is_write" v-model="formData['review_'+item.id]" :placeholder="'直接輸入'" style="margin-right:5px;"></el-input>
              </p>
            </el-col>
          </el-row>
        </li>
      </template>
    </ul>
    <!-- {{formData}} -->
  </div>
</template>

<script>
export default {
  name: 'ReviewList',
  props: {
    // 顯示類型 默認為現金交易類型 1 ，2為匯款
    showType: {
      required: true,
      type: Number,
      default: 1
    },
    // 顯示的數據
    showData: {
      type: Object,
      default: () => { }
    },
    resultData: {
      required: true,
      type: Object,
      default: () => { }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading:true,
      formData: {},
      reviewList: {},
    }
  },
  methods: {
    async getReviewList () {
      let reviewList = [];
      await this.post('/api/order/review_list', {})
        .then(response => {
          // console.log(response);
          reviewList = response;
          this.loading = false;
        }).catch(error => {
          console.log(error);
        })

      return reviewList;
    }
  },
  async created () {
    let reviewList = await this.getReviewList();
    // let vuexReviewList = [];
    // 動態組裝接收對象
    if (!this.showData) {
      let formData = {};
      reviewList.forEach(item => {
        if (item.scene == 0 || this.showType == item.scene) {
          let keyName = 'review_' + item.id;
          formData[keyName] = '';
        }
      });
      this.formData = JSON.parse(JSON.stringify(formData));
    } else {
      this.formData = this.showData;
    }

    let tmp = reviewList.map(item => {
      let switchDefaultValue = item.switch_default_values.split(",");
      item.switchDefaultValue = switchDefaultValue;
      return item;
    });
    this.reviewList = JSON.parse(JSON.stringify(reviewList));
  },
  watch: {
    formData: {
      handler: function (val) {
        this.$emit('update:resultData', this.formData);
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.verify-box {
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.review-list {
  width: 100%;
}

li {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  margin-top:15px;
}
.verify-box li p {
  align-items: center;
  display: flex;
}
.red-mark {
  color: rgb(255, 73, 73);
}
.mb15{
  margin-bottom: 15px;
}

</style>
